import { render, staticRenderFns } from "./QuestionInputCheckbox.vue?vue&type=template&id=41184512&scoped=true&"
import script from "./QuestionInputCheckbox.vue?vue&type=script&lang=js&"
export * from "./QuestionInputCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41184512",
  null
  
)

export default component.exports